import initialState from "./InitialState";

const userReducer = (state=initialState.userProfile, action) => {
    if(action.type.type == "PROFILE_REFRESHED"){
        return action.payload};
    return state
}

export default userReducer;